import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EMenuTypes } from 'projects/common/src/app/enumerables';
import { IRawApplication } from 'projects/common/src/app/interfaces/remote-models/raw-application';
import { IRawApplicationChild } from 'projects/common/src/app/interfaces/remote-models/raw-application-child';
import { CacheService, ParameterHandlerService } from 'projects/common/src/app/services';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { objectPathExists } from 'projects/common/src/app/services/utils/utilities';
import { Subscription } from 'rxjs';
import { DashboardFacade } from 'src/app/modules/core/store/dashboard/dashboard.facade';
import { DashboardService } from 'src/app/modules/dashboard/services/dashboard/dashboard.service';
import { environment } from 'src/environments/environment';
import { IZone } from '../../../dashboard/interfaces/zone';
import { ZoneHandlerService } from '../../../dashboard/services/zone-handler/zone-handler.service';
import { ESidebarState } from '../../enumerables/sidebarState';
import { MenuService } from '../../services/menu.service';
import { StateSidebarService } from '../../services/state-sidebar.service';
import { SignalRMessengerService } from 'src/app/modules/core/services/signal-r/signalr-messenger.service';
import { MessengerFacade } from 'src/app/modules/core/store/messenger/messenger.facade';

@Component({
  selector: 'app-menu-option',
  templateUrl: './menu-option.component.html',
  styleUrls: ['./menu-option.component.scss'],
})
export class MenuOptionComponent implements OnInit, AfterViewInit, OnDestroy {
  public readonly REGEX_NUMBER = /\d/g;
  private $selectionState: boolean;
  public totalUnreadMessages: number;
  public get selectionState(): boolean {
    return this.$selectionState;
  }
  public set selectionState(value: boolean) {
    this.$selectionState = value;
  }

  private $menuCollapsed: boolean;
  public get menuCollapsed(): boolean {
    return this.$menuCollapsed;
  }
  public set menuCollapsed(value: boolean) {
    this.$menuCollapsed = value;
  }

  public title: string;
  public detail: string;
  public icon: string;

  @Input()
  public configuration: IRawApplicationChild;
  @Input()
  public father: IRawApplicationChild;

  @Input()
  public showIcon = false;

  public secondTitle = '';
  public detailVisibility = true;
  public showChildren: boolean;
  public plChild = 0;
  public underline = false;
  public toggled = false;

  private menuSelectionSubscription: Subscription;
  private menuSelectionToggleSubscription: Subscription;
  private sidebarStateSubscription: Subscription;
  private menuDetailVisibilitySubscription: Subscription;
  private unreadMessageSub: Subscription;
  private subscriptions: Subscription[] = [];

  public intervalCheck: Subscription;
  private currentMenu: IRawApplication;

  constructor(
    public dashboardFacade: DashboardFacade,
    public menuService: MenuService,
    public sidebarService: StateSidebarService,
    private routeService: Router,
    private cacheService: CacheService,
    private zoneHandlerSvc: ZoneHandlerService,
    private dashboardService: DashboardService,
    private languajeService: LanguageService,
    private parameterService: ParameterHandlerService,
    private cdr: ChangeDetectorRef,
    private _messengerFacade: MessengerFacade,
    private signalRMessengerService: SignalRMessengerService,
  ) {}

  // /**
  //  * On init component
  //  */
  public ngOnInit(): void {
    this.initializeMenu();
    this.setMenuSelection();
    this.determineChildVisibility();
    this.initializeMessenger();
  }

  trackByMenuId(index: number, item: IRawApplicationChild): number {
    return item.menuId;
  }

  private initializeMenu(): void {
    this.currentMenu = this.cacheService.session('selectedMenu') || this.configuration;
    this.cacheService.saveSession('selectedMenu', this.currentMenu);

    this.title = this.configuration.name;
    this.detail = this.configuration.description;
    this.icon = this.configuration.icon;
  }

  private setMenuSelection(): void {
    const menuSession = this.cacheService.session('selectedMenu');
    if (menuSession) {
      this.menuService.setSelection(menuSession);
    }
  }

  private determineChildVisibility(): void {
    this.showChildren =
      this.configuration.menuId === this.currentMenu.menuParentId ||
      (this.selectionState && this.currentMenu.childs.length > 0) ||
      (objectPathExists(this.currentMenu, 'routerState') && this.currentMenu.routerState.includes(this.configuration.name));
  }

  private initializeMessenger(): void {
    if (this.configuration.name === 'messages') {
      this._messengerFacade.getMachinesMessages();
      this.signalRMessengerService.startConnection();
      this.unreadMessageSub = this._messengerFacade.sidebarNotification$.subscribe({
        next: (unreadMessages) => {
          this.totalUnreadMessages = unreadMessages;
        },
      });
      this.subscriptions.push(this.unreadMessageSub);
    }
  }

  /**
   * After view init
   */
  public ngAfterViewInit(): void {
    this.menuSelectionSubscription = this.menuService.menuSelectionSource.subscribe((selection: IRawApplicationChild) => {
      // // avoid overwriting the selectionState if the menu is a toggle
      if (!selection || !selection.menuId) {
        console.warn('menuSelectionSource emitió un valor inválido:', selection);
        return;
      }

      // validate if the stored menu is different from the emitted menu
      const storedMenu = this.cacheService.session('selectedMenu');
      if (storedMenu && storedMenu.menuId !== selection.menuId) {
        return;
      }

      this.cdr.detectChanges();
    });

    this.sidebarStateSubscription = this.sidebarService.stateSource.subscribe((state: ESidebarState) => {
      this.menuCollapsed = state === ESidebarState.closed;
      this.cdr.detectChanges();
    });

    this.menuDetailVisibilitySubscription = this.menuService.detailVisibilitySource.subscribe((data: boolean) => {
      this.detailVisibility = data;
      this.cdr.detectChanges();
    });

    this.menuSelectionToggleSubscription = this.menuService.menuSelectionToggleSource.subscribe((selection: IRawApplicationChild) => {
      if (
        selection.menuId === this.configuration.menuId &&
        [EMenuTypes.TOGGLE, EMenuTypes.TOGGLELINK].includes(this.configuration.type as EMenuTypes)
      ) {
        this.showChildren = !this.showChildren;
      } else if (
        objectPathExists(selection, 'routerState') &&
        selection.routerState.includes(this.configuration.name) &&
        this.configuration.type === EMenuTypes.TOGGLE
      ) {
        this.showChildren = true;
      } else {
        this.showChildren = false;
      }
      this.cdr.detectChanges();
    });

    this.subscriptions.push(this.menuSelectionSubscription);
    this.subscriptions.push(this.sidebarStateSubscription);
    this.subscriptions.push(this.menuDetailVisibilitySubscription);
    this.subscriptions.push(this.menuSelectionToggleSubscription);
  }

  /**
   * On destroy coponent
   */
  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  public clickHandler(): void {
    this.secondTitle = '';

    if (this.toggled) {
      this.toggled = false;
      return;
    }

    if (this.configuration.type === EMenuTypes.TOGGLE) {
      this.menuService.setToggleMenu(this.configuration);
      return;
    }

    this.handleNavigation();

    // Guardar en sesión la selección actual
    this.cacheService.saveSession('selectedMenu', this.configuration);
    this.cacheService.saveSession('secondTitle', this.secondTitle);

    this.dashboardFacade.changeButtonIcon();
    this.dashboardFacade.getIsChangeView(false);
    this.dashboardFacade.changeTitleDashboard(this.secondTitle);
  }

  private handleNavigation(): void {
    const isDashboard = this.isDashboardRoute();
    const { type, url } = this.configuration;

    switch (type) {
      case EMenuTypes.TOGGLE:
        this.menuService.setToggleMenu(this.configuration);
        break;

      case EMenuTypes.TOGGLELINK:
        this.menuService.setToggleMenu(this.configuration);
        this.menuService.setSelection(this.configuration);
        if (isDashboard) this.setDashboardContext();
        setTimeout(() => this.goToLink(), 0);
        break;

      case EMenuTypes.LINK:
        this.menuService.setSelection(this.configuration); // 🔹 Agregado para asegurar selección
        if (isDashboard) {
          this.setDashboardContext();
          setTimeout(() => this.goToLink(), 0);
        } else {
          setTimeout(() => this.routeService.navigate([url]), 0);
        }

        break;
      default:
        break;
    }
  }

  private isDashboardRoute(): boolean {
    return this.configuration?.routerState?.includes('dashboard') ?? false;
  }

  /**
   * Set dashboard context
   * @description set context dashboard, save selected zone in cache and update dashboard title.
   */
  private setDashboardContext(): void {
    this.secondTitle = this.buildBreadCrumb(this.configuration);
    this.dashboardFacade.getIsTitleDashboard(true);

    const zoneId = parseFloat(this.configuration.url.split('/').pop());
    const zoneSelected: IZone = { zoneId, zoneName: this.configuration.visibleName };

    this.cacheService.saveSession('selectedZone', zoneSelected);
  }

  public clickToggle(): void {
    if (this.configuration.type === EMenuTypes.TOGGLE || this.configuration.type === EMenuTypes.TOGGLELINK) {
      this.toggled = true;
      this.menuService.setToggleMenu(this.configuration);
    }
  }

  /**
   * Generates the url of route node.
   */
  public getUrlPath(app: IRawApplicationChild[], path = ''): string {
    const routerState = this.configuration.routerState.split('.');
    for (const appChild of app) {
      if (routerState.includes(appChild.name)) {
        path = `${path}/${appChild.url}`;
        if (appChild.hasChildren) {
          path = this.getUrlPath(appChild.childs, path);
        } else {
          path = `${environment.homePath}${path}`;
        }
      }
    }
    return path;
  }

  /**
   * Find path to compare
   */
  public goToLink() {
    const pathArray = this.configuration.url.split('/');
    if (pathArray.some((value) => !isNaN(+value))) {
      this.zoneHandlerSvc.verifySelectedZone(this.configuration.url);
      let routes = this.cacheService.session('app');
      routes = routes.childs as IRawApplicationChild[];

      let navigateTo;
      navigateTo = this.getUrlPath(routes, '');
      if (pathArray.length === 1) {
        navigateTo = (navigateTo && navigateTo.split('/')) || ['app'];
      } else {
        const havePathApp = navigateTo.includes('app');
        navigateTo = [havePathApp ? navigateTo : environment.homePath + navigateTo];
      }
      this.routeService.navigate([...navigateTo]);
    } else {
      this.dashboardService.initializeDashboard();
      this.routeService.navigate([environment.homePath, 'dsh', this.configuration.url]);
    }
  }

  /**
   * Find parent menu
   * @param menuId
   * @returns
   */
  private findParentMenu(menuId: number): IRawApplicationChild | undefined {
    const searchMenu = (menuList: IRawApplicationChild[]): IRawApplicationChild | undefined => {
      for (const menu of menuList) {
        if (menu.menuId === menuId) {
          return menu;
        }
        if (menu.childs && menu.childs.length > 0) {
          const found = searchMenu(menu.childs);
          if (found) {
            return found;
          }
        }
      }
      return undefined;
    };
    return searchMenu(this.menuService.menuConfiguration);
  }

  /**
   *  Build BreadCrumb title
   */
  private buildBreadCrumb(menuItem: any): string {
    const titleParts: string[] = [];
    while (menuItem) {
      if (menuItem.visibleName && menuItem.visibleName.toLowerCase() !== 'dashboard') {
        titleParts.unshift(this.languajeService.message(menuItem.visibleName.toLowerCase()));
      }
      menuItem = this.findParentMenu(menuItem.menuParentId);
    }
    return `/ ${titleParts.join(' / ')}`;
  }
}
